import React from 'react';

const InfoIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-400 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const AiDisclaimer: React.FC = () => {
    return (
        <div className="bg-blue-900/20 border border-blue-800/50 rounded-lg p-3 text-xs text-gray-400 flex items-start gap-3">
            <InfoIcon />
            <div>
                <strong className="text-yellow-400/80">AI-Powered CDS Tool:</strong>
                <p className="mt-1">AI-generated content requires independent verification. This is a supplemental tool, not a substitute for clinical judgment. Do not enter PHI.</p>
            </div>
        </div>
    );
};

export default AiDisclaimer;